export const SUFFIX_EMISSION_NUMERATOR = 'kg CO₂e';

export const MAX_BULK_PCF_REQUEST_SELECTION_LIMIT = 99999;
export const MAX_BULK_TRANSFER_COMPONENTS_SELECTION_LIMIT = 99999;

export const EMISSION_MIN_FRACTION_DIGIT = 1;
export const EMISSION_MAX_FRACTION_DIGIT = 6;

export const MAX_TAGS_PER_PRODUCT = 20;
export const MAX_TAG_LENGTH = 64;

export const MAX_PROCESS_PER_CALCULATION = 20;

export const PRODUCTS_TABLE_PAGE_SIZE = 50;
export const COMPONENTS_TABLE_PAGE_SIZE = 50;
export const BULK_PCF_EXPORT_TABLE_PAGE_SIZE = 50;
export const BULK_TRANSFER_COMPONENTS_TABLE_PAGE_SIZE = 50;
export const BULK_REQUEST_PCF_TABLE_PAGE_SIZE = 50;
export const SELECT_PRODUCT_DROPDOWN_PAGE_SIZE = 50;

export const SELECT_COMPONENT_FOR_CALCULATION_TABLE_PAGE_SIZE = 50;
